export default "__VITE_ASSET__DKUKID7s__"